import { Control, FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SelectFormField } from '@/components';

export const SubscriptionStatusFormField = <V extends FieldValues & { status: string }>({
  control,
}: {
  control: Control<V>;
}) => {
  const { t } = useTranslation();

  return (
    <SelectFormField
      control={control}
      name={'status' as Path<V>}
      label={t('shared.ndiOrganizationSubscriptions.fields.status')}
      options={[
        { value: 'active', label: t('shared.ndiOrganizationSubscriptions.statusOptions.active') },
        { value: 'inactive', label: t('shared.ndiOrganizationSubscriptions.statusOptions.inactive') },
      ]}
    />
  );
};
